export const styles = {
	loader: {
		marginLeft: '8px'
	},
	wrapper: {
		margin: '8px',
		position: 'relative',
		flexGrow: 1,
		display: 'flex'
	},
	buttonProgress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: '-12px',
		marginLeft: '-12px'
	}
};
